import Keycloak from 'keycloak-js';

export const getToken = (keycloak: Keycloak) => {
  return new Promise<string>((resolve, reject) => {
    if (keycloak.token) {
      keycloak
        .updateToken(5)
        .then(() => {
          resolve(keycloak.token as string);
        })
        .catch(() => {
          reject('Failed to refresh token');
        });
    } else {
      reject('Not logged in');
    }
  });
};
